import dispatcher from "./Dispatcher";
import { EventEmitter } from "events";

class NewStore extends EventEmitter {
  constructor() {
    super();
    this.CHANGE_EVENT = "change";
  }

  handleActions(action) {
    if(action.actionType === "GET_RANDOM_RESPONSE"){
      this.CHANGE_EVENT = action;
      this.emit("storeUpdated");
    } else if(action.actionType === "SHOW_TOAST"){
      this.CHANGE_EVENT = action;
      this.emit("openToast");
    }
  }

  getactivePage() {
    return this.CHANGE_EVENT;
  }

}

const newStore = new NewStore();
dispatcher.register(newStore.handleActions.bind(newStore));
export default newStore;



// WEBPACK FOOTER //
// ./src/pages/Store.js